class TiloPageJS {
  constructor() {
    window.addEventListener('load', () => {
      setTimeout(() => {
        window.scrollTo(0, 0);
      }, 50);

      this.initFabricSlides();
      this.initComfortSlides();
      this.initHomeSlide();
      this.initGsapFadeUp();
      this.initDrawer();
    });
  }

  initFabricSlides() {
    const sliders = document.querySelectorAll('.js-fabric-slide');
    if (sliders.length === 0) return;

    sliders.forEach((slider) => {

      const splide = new Splide(slider, {
        type: 'loop',
        perPage: 1,
        gap: '20px',
        arrowPath:
          'M14.053 40a1.675 1.675 0 0 0 1.361-.694l13.267-18.322a1.677 1.677 0 0 0 0-1.969L15.409.694a1.678 1.678 0 1 0-2.718 1.969L25.25 20 12.695 37.337A1.678 1.678 0 0 0 14.053 40',
      });

      splide.mount();
      slider.splideInstance = splide;
    });
  }

  initComfortSlides() {
    const sliders = document.querySelectorAll('.js-comfort-slide');
    if (sliders.length === 0) return;

    sliders.forEach((slider) => {

      const splide = new Splide(slider, {
        autoplay: 'play',
        type: 'loop',
        perPage: 1,
        gap: '20px',
        arrowPath:
          'M14.053 40a1.675 1.675 0 0 0 1.361-.694l13.267-18.322a1.677 1.677 0 0 0 0-1.969L15.409.694a1.678 1.678 0 1 0-2.718 1.969L25.25 20 12.695 37.337A1.678 1.678 0 0 0 14.053 40',
      });

      splide.mount();
      slider.splideInstance = splide;
    });
  }

  initHomeSlide() {
    const homeSlider = document.querySelector('.js-hero-slide');
    if (!homeSlider) return;

    const splide = new Splide(homeSlider, {
      type: 'fade',
      autoplay: true,
      rewind: true,
      interval: 9000,
      speed: 5500,
      arrows: false
    });

    splide.on('move', function () {
      const lastElement = splide.root.querySelector('.splide__slide:last-child span');
      if (!lastElement) return;

      if (splide.index === 0) {
        lastElement.classList.add('is-prev');
      } else {
        lastElement.classList.remove('is-prev');
      }
    });

    splide.mount();
    homeSlider.splideInstance = splide;
  }

  initGsapFadeUp() {
    gsap.registerPlugin(ScrollTrigger);

    gsap.utils.toArray('.js-h1-fade-up').forEach((el) => {
      gsap.from(el, {
        scrollTrigger: {
          trigger: el,
          start: "top 70%",
          toggleActions: "play none none none",
        },
        delay: 1,
        opacity: 0,
        y: 50,
        duration: 1.3,
        ease: "power2.out"
      });
    });

    gsap.utils.toArray('.js-fade-up').forEach((el) => {
      gsap.from(el, {
        scrollTrigger: {
          trigger: el,
          start: "top 70%",
          toggleActions: "play none none none",
        },
        opacity: 0,
        y: 50,
        duration: 1,
        ease: "power2.out"
      });
    });
  }

  initDrawer() {
    new this.Drawer();
  }

  Drawer = class {
    constructor() {
      this.drawer = document.querySelector('.js-menu-body');
      this.toggleButton = document.querySelector('.js-menu-btn');
      this.closeButton = document.querySelector('.js-menu-close');

      this.isOpen = false;
      this.scrollY = 0;

      this.bindEvents();
    }

    bindEvents() {
    if (!this.drawer || !this.toggleButton) return;

      this.toggleButton.addEventListener('click', (e) => {
        e.preventDefault();
        this.openDrawer();
      });

      if (this.closeButton) {
        this.closeButton.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          this.closeDrawer();
        });
      }

      this.drawer.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.addEventListener('click', (e) => {
          e.preventDefault();

          const targetId = anchor.getAttribute('href').substring(1);
          const targetElem = document.getElementById(targetId);

          if (targetElem) {
            this.closeDrawer();

            setTimeout(() => {
              const targetPosition = targetElem.getBoundingClientRect().top + window.pageYOffset;

              gsap.to(window, {
                duration: 0.6,
                scrollTo: targetPosition,
                ease: "power1.inOut"
              });
            }, 350);
          }
        });
      });
    }

    openDrawer() {
      if (this.isOpen) return;

      this.scrollY = window.scrollY;
      document.body.style.position = 'fixed';
      document.body.style.top = `-${this.scrollY}px`;
      document.body.style.width = '100%';

      this.drawer.classList.add('is-open');

      gsap.fromTo(this.drawer, {
        opacity: 0,
        display: 'none',
        visibility: 'hidden',
      }, {
        opacity: 1,
        display: 'grid',
        visibility: 'visible',
        duration: 0.2,
        ease: 'power2.out',
        onComplete: () => {
          gsap.fromTo(
            this.drawer.querySelectorAll('.tilo_drawer_menu li'),
            {
              opacity: 0,
              y: 15,
            },
            {
              opacity: 1,
              y: 0,
              duration: 0.5,
              ease: 'power2.out',
              stagger: 0.13,
            }
          );
        }
      });
      this.isOpen = true;
    }

    closeDrawer() {
      if (!this.isOpen) return;

      gsap.to(this.drawer, {
        opacity: 0,
        duration: 0.3,
        ease: 'power2.in',
        onComplete: () => {
          this.drawer.classList.remove('is-open');
          gsap.set(this.drawer, { display: 'none' });

          gsap.set(this.drawer.querySelectorAll('.tilo_drawer_menu li'), {
            opacity: 0,
            y: 15,
          });

          document.body.style.position = '';
          document.body.style.top = '';
          document.body.style.width = '';
          window.scrollTo(0, this.scrollY);

          this.isOpen = false;
        }
      });
    }
  };
}

// グローバル登録 & 実行
window.TiloPageJS = TiloPageJS;
new TiloPageJS();
